// Panel tarjimasi (1/3): ruscha. Kalit — o'zbekcha matn.
// Tafsilot: ./index.js.
const lugat = {
  // --- GPS davomat ---
  "Texnik muammo": "Техническая проблема",
  "Shaxsiy sabab": "Личная причина",
  "Batareya tejash": "Экономия батареи",
  "Boshqa": "Другое",
  "Keldi": "Пришёл",
  "Hududdan chiqdi": "Покинул зону",
  "Qaytdi": "Вернулся",
  "Ish tugadi": "Работа окончена",
  "⛔ Soxta GPS": "⛔ Поддельный GPS",
  "🟢 Ish joyida": "🟢 На рабочем месте",
  "🔵 Tekshiruvda (maydonda)": "🔵 На проверке (в поле)",
  "Tekshiruvda": "На проверке",
  "Tekshiruvga chiqdi (tizim)": "Выехал на проверку (система)",
  "Qaytdi (tizim)": "Вернулся (система)",
  "Maydonda — nazorat tashrifi": "В поле — контрольное посещение",
  "Inspektor mahkumga tashrif yoki sayyor sudni qayd etsa, uning joylashuvi shundan ham ma'lum bo'ladi — bunday hollarda tizim davomatga \"Tekshiruvda\" deb o'zi yozib qo'yadi.":
    "Если инспектор фиксирует посещение осуждённого или выездной суд, его местоположение известно и оттуда — в таких случаях система сама отмечает в табеле «На проверке».",
  "🟠 Hududdan chiqqan": "🟠 Покинул зону",
  "🟡 Zona tashqarida": "🟡 Вне зоны",
  "🔴 GPS o'chiq": "🔴 GPS выключен",
  "⚙️ Ish joyi biriktirilmagan": "⚙️ Рабочее место не назначено",
  "⚪ Belgilanmagan": "⚪ Не отметился",
  "GPS davomat nazorati": "GPS-контроль посещаемости",
  "Xodimlar ilovada \"Ish joyidaman\" tugmasini bosganda joylashuvi bir marta olinadi. Doimiy kuzatuv yo'q. Ish vaqtida hududdan chiqsa — sababini izoh qilib yozadi, qaytganida yana \"Ish joyidaman\" tugmasini bosadi.": "Когда сотрудник нажимает в приложении кнопку «Я на рабочем месте», его местоположение фиксируется один раз. Постоянного слежения нет. Если в рабочее время он покидает зону — указывает причину, а вернувшись, снова нажимает «Я на рабочем месте».",
  "{soxta_gps} ta xodimda soxta joylashuv aniqlandi.": "У {soxta_gps} сотрудников обнаружено поддельное местоположение.",
  "Telefonda \"fake GPS\" ilovasi ishlagan — koordinata yozib olindi, lekin \"ish joyida\" deb tan olinmadi. Ro'yxatdan ko'rib chiqing.": "На телефоне работало приложение «fake GPS» — координаты записаны, но отметка «на рабочем месте» не засчитана. Проверьте по списку.",
  "{zonasiz} ta xodimga ish joyi biriktirilmagan.": "{zonasiz} сотрудникам не назначено рабочее место.",
  "Ular belgilanganda \"ish joyida\" deb tan olinmaydi — Foydalanuvchilar sahifasidan har biriga o'z ish joyini biriktiring.": "Их отметки не засчитываются как «на рабочем месте» — назначьте каждому рабочее место на странице «Пользователи».",
  "Ish joyida": "На рабочем месте",
  "Hududdan chiqqan": "Покинул зону",
  "Zona tashqarida": "Вне зоны",
  "GPS o'chiq": "GPS выключен",
  "Belgilanmagan": "Не отметился",
  "Bugungi holat": "Сегодня",
  "Tarix": "История",
  "🔍 Xodim ismi yoki logini...": "🔍 Имя или логин сотрудника...",
  "Yangilash": "Обновить",
  "Yuklanmoqda...": "Загрузка...",
  "Holat": "Статус",
  "Vaqt": "Время",
  "Tafsilot": "Подробности",
  "ish joyi biriktirilmagan": "рабочее место не назначено",
  "Izoh:": "Комментарий:",
  "yozilmagan": "не указан",
  "Ish joyidan {distance_meters} m uzoqda · hali qaytmagan": "{distance_meters} м от рабочего места · ещё не вернулся",
  "O'z ish joyidan {distance_meters} m uzoqda": "{distance_meters} м от своего рабочего места",
  "Ish joyi biriktirilmagan — tekshirib bo'lmaydi": "Рабочее место не назначено — проверить нельзя",
  "Bugun belgilanmagan": "Сегодня не отметился",
  "Xaritada": "На карте",
  "Hali xodim yo'q.": "Сотрудников пока нет.",
  "Hech narsa topilmadi.": "Ничего не найдено.",
  "Sana va vaqt": "Дата и время",
  "Turi": "Тип",
  "Izoh: {note}": "Комментарий: {note}",
  "xaritada ↗": "на карте ↗",
  "Bu sanada yozuv yo'q.": "За эту дату записей нет.",
  "Ish joyidan {distance_meters} m": "{distance_meters} м от рабочего места",
  "Xodim joylashuvi": "Местоположение сотрудника",
  "GPS aniqligi ±{round} m": "Точность GPS ±{round} м",
  "Google Maps'da ochish ↗": "Открыть в Google Maps ↗",

  // --- Kitoblar ---
  "Kitob nomi va havolani kiriting": "Введите название книги и ссылку",
  "\"{title}\" qo'shildi.": "«{title}» добавлено.",
  "Kitob qo'shilmadi.": "Книга не добавлена.",
  "\"{title}\" yangilandi.": "«{title}» обновлено.",
  "Saqlanmadi.": "Не сохранено.",
  "\"{title}\" o'chirilsinmi?\n\nBu amalni qaytarib bo'lmaydi.": "Удалить «{title}»?\n\nЭто действие нельзя отменить.",
  "\"{title}\" o'chirildi.": "«{title}» удалено.",
  "O'chirib bo'lmadi.": "Не удалось удалить.",
  "jami {soni} ta": "всего {soni}",
  "Yangi kitob": "Новая книга",
  "Kitob nomi *": "Название книги *",
  "Muallifi": "Автор",
  "Yuklab olish havolasi * (masalan: https://server.uz/kitob.pdf)": "Ссылка для скачивания * (например: https://server.uz/kitob.pdf)",
  "Qisqacha mazmuni": "Краткое содержание",
  "Qo'shilmoqda...": "Добавление...",
  "Qo'shish": "Добавить",
  "🔍 Kitob nomi yoki muallifi bo'yicha qidirish...": "🔍 Поиск по названию или автору...",
  "Kitob nomi": "Название книги",
  "Havola": "Ссылка",
  "Amallar": "Действия",
  "Ochish ↗": "Открыть ↗",
  "Tahrirlash": "Редактировать",
  "O'chirish": "Удалить",
  "Hali kitob qo'shilmagan.": "Книг пока нет.",
  "\"{search}\" bo'yicha hech narsa topilmadi.": "По запросу «{search}» ничего не найдено.",
  "Kitobni tahrirlash": "Редактирование книги",
  "Yuklab olish havolasi": "Ссылка для скачивания",
  "Bekor qilish": "Отмена",
  "Saqlanmoqda...": "Сохранение...",
  "Saqlash": "Сохранить",

  // --- Kunlik vazifalar ---
  "Shahar-tuman": "Город/район",
  "inspektor va katta inspektorlar": "инспекторы и старшие инспекторы",
  "Apparat": "Аппарат",
  "apparat xodimlari": "сотрудники аппарата",
  "Nazorat": "Контроль",
  "Hujjat": "Документ",
  "Yig'ilish": "Собрание",
  "Hisobot": "Отчёт",
  "Yuqori": "Высокая",
  "O'rta": "Средняя",
  "Past": "Низкая",
  "Vazifa nomi * (masalan: Probatsiyachilarni tekshirish)": "Название задачи * (например: Проверка лиц на пробации)",
  "Kategoriya: {label}": "Категория: {label}",
  "Muhimligi: {label}": "Важность: {label}",
  "Faqat bitta kunga (belgilanmasa — har kuni takrorlanadi)": "Только на один день (если не указано — повторяется ежедневно)",
  "Vazifa nomini yozing": "Укажите название задачи",
  "Vazifa qo'shilmadi.": "Задача не добавлена.",
  "Vazifa yangilandi.": "Задача обновлена.",
  "\"{title}\" o'chirilsinmi?\n\nEski hisobotlarda u saqlanib qoladi, faqat bugundan boshlab xodimlarga ko'rinmaydi.": "Удалить «{title}»?\n\nВ старых отчётах она сохранится, но с сегодняшнего дня сотрудники её не увидят.",
  "Ro'yxat ikkita: apparat xodimlari uchun va shahar-tuman xodimlari uchun. Xodim ilovada bajarganiga galochka qo'yadi, bajarmaganiga sabab yozadi — fayl yuklamaydi.": "Списков два: для сотрудников аппарата и для сотрудников города/района. В приложении сотрудник ставит галочку за выполненное, а для невыполненного пишет причину — файлы не загружаются.",
  "Vazifalar ro'yxati": "Список задач",
  "Bajarish holati": "Ход выполнения",
  "Yangi vazifa — {label}": "Новая задача — {label}",
  "{label} ro'yxati": "Список: {label}",
  "Bugun": "Сегодня",
  "kuni kuchda bo'lgan vazifalar — jami {soni} ta": "— действующие задачи, всего {soni}",
  "faqat {slice}": "только {slice}",
  "har kuni": "ежедневно",
  "Bu ro'yxat bo'sh. Vazifa qo'shmaguningizcha xodimlarda hech narsa ko'rinmaydi.": "Список пуст. Пока вы не добавите задачи, сотрудники ничего не увидят.",
  "Jami topshiriq": "Всего заданий",
  "Bajarildi": "Выполнено",
  "Bajarilmadi": "Не выполнено",
  "Samaradorlik": "Эффективность",
  "Xodimlar — {sana}": "Сотрудники — {sana}",
  "Yopish": "Закрыть",
  "Batafsil": "Подробнее",
  "{bajardi} ta bajardi": "выполнили: {bajardi}",
  "{bajarmadi} ta bajarmadi": "не выполнили: {bajarmadi}",
  "{kutilmoqda} ta kutilmoqda": "ожидают: {kutilmoqda}",
  "Sabab: {reason}": "Причина: {reason}",
  "{toLocaleTimeString} da bajarildi": "выполнено в {toLocaleTimeString}",
  "Bu guruh uchun vazifa qo'shilmagan.": "Для этой группы задачи не добавлены.",
  "Lavozimi belgilangan xodim yo'q. Foydalanuvchilar sahifasidan har biriga \"Apparat\" yoki \"Shahar-tuman\" lavozimini biriktiring.": "Нет сотрудников с назначенной должностью. На странице «Пользователи» назначьте каждому должность «Аппарат» или «Город/район».",
  "Vazifani tahrirlash": "Редактирование задачи",

  // --- Dashboard ---
  "Foydalanuvchilar": "Пользователи",
  "Testlar": "Тесты",
  "Yangiliklar": "Новости",
  "Kitoblar": "Книги",
  "Test natijalari": "Результаты тестов",
  "Top foydalanuvchilar": "Лучшие пользователи",
  "Ism": "Имя",
  "Daraja": "Звание",
  "Bo'lim": "Отдел",
  "Ball": "Балл",

  // --- Tumanlar ---
  "Tumanlar ro'yxatini olishda xato": "Ошибка загрузки списка районов",
  "Tuman nomini kiriting": "Введите название района",
  "\"{name}\" qo'shildi.": "«{name}» добавлен.",
  "Tuman qo'shilmadi.": "Район не добавлен.",
  "Tuman yangilandi.": "Район обновлён.",
  "\"{name}\" o'chirilsinmi?\n\nDIQQAT: {soni} ta xodimning tuman biriktiruvi bekor qilinadi va ular yig'ilishda ko'rinmay qoladi.": "Удалить «{name}»?\n\nВНИМАНИЕ: у {soni} сотрудников будет снята привязка к району, и они перестанут отображаться на собраниях.",
  "\"{name}\" tumani o'chirilsinmi?": "Удалить район «{name}»?",
  "Ovozli yig'ilishning asosiy birligi. Rahbar yig'ilishda aynan tumanlarni ko'radi va so'z beradi — shuning uchun har bir ishtirokchi xodim tumanga biriktirilgan bo'lishi shart.": "Основная единица голосового собрания. Руководитель видит на собрании именно районы и предоставляет им слово — поэтому каждый участник должен быть привязан к району.",
  "Yangi tuman": "Новый район",
  "Tuman nomi * (masalan: Chilonzor)": "Название района * (например: Чиланзар)",
  "Nomi": "Название",
  "Xodimlar": "Сотрудники",
  "Faol": "Активен",
  "O'chiq": "Отключён",
  "Bekor": "Отмена",
  "Hali tuman qo'shilmagan. Tumansiz ovozli yig'ilish o'tkazib bo'lmaydi.": "Районов пока нет. Без районов провести голосовое собрание нельзя.",

  // --- Yuklab olishlar ---
  "Kitob yuklab olishlari": "Скачивания книг",
  "Jami kitoblar": "Всего книг",
  "Yuklab olingan kitoblar": "Скачанные книги",
  "Yuklab olgan xodimlar": "Скачавшие сотрудники",
  "Jami yuklab olishlar": "Всего скачиваний",
  "Kitoblar bo'yicha": "По книгам",
  "Xodimlar bo'yicha": "По сотрудникам",
  "🔍 Kitob nomi yoki muallifi...": "🔍 Название или автор книги...",
  "Hali hech kim kitob yuklab olmagan.": "Пока никто не скачивал книги.",
  "{count} xodim oldi": "скачали: {count}",
  "hech kim olmagan": "никто не скачал",
  "{count} ta kitob": "книг: {count}",
  "Kitob": "Книга",
  "Login": "Логин",
  "Birinchi marta": "Первый раз",
  "Oxirgi marta": "Последний раз",
  "Marta": "Раз",

  // --- Qonun hujjatlari ---
  "Hujjat nomi va PDF havolasini kiriting": "Введите название документа и ссылку на PDF",
  "Hujjat qo'shilmadi.": "Документ не добавлен.",
  "Mobil ilovadagi \"Qonun Ustuvorligi\" bo'limida ko'rinadi — xodim bosganda PDF ilova ichida ochiladi.": "Отображается в разделе «Верховенство закона» мобильного приложения — при нажатии PDF открывается внутри приложения.",
  "Yangi hujjat": "Новый документ",
  "Hujjat nomi * (masalan: Jinoyat kodeksi)": "Название документа * (например: Уголовный кодекс)",
  "PDF havolasi * (masalan: https://server.uz/hujjat.pdf)": "Ссылка на PDF * (например: https://server.uz/hujjat.pdf)",
  "🔍 Hujjat nomi bo'yicha qidirish...": "🔍 Поиск по названию документа...",
  "Hujjat nomi": "Название документа",
  "Hali hujjat qo'shilmagan.": "Документов пока нет.",
  "Hujjatni tahrirlash": "Редактирование документа",
  "PDF havolasi": "Ссылка на PDF",

  // --- Xarita komponenti ---
  "Joylashuv ma'lumoti yo'q": "Нет данных о местоположении",
  "Ish zonasi": "Рабочая зона",
  "Radius: {zoneRadius} m": "Радиус: {zoneRadius} м",
  "Xodim": "Сотрудник",
  "Aniqlik: ±{round} m": "Точность: ±{round} м",

  // --- Kirish ---
  "Login yoki parol noto'g'ri": "Неверный логин или пароль",
  "Sessiya muddati tugadi. Iltimos, qaytadan kiring.": "Сессия истекла. Пожалуйста, войдите снова.",
  "Parol": "Пароль",
  "Kirish": "Войти",

  // --- Mahkumlar reyestri ---
  "Axloq tuzatish ishlari": "Исправительные работы",
  "Ish beruvchi xabarnomani olgan kun *": "День получения уведомления работодателем *",
  "Boshqa joyda o'talsa — mahkum ishga chiqqan kun (63-band)": "Если отбывается в другом месте — день выхода осуждённого на работу (п. 63)",
  "Ozodlikni cheklash": "Ограничение свободы",
  "Probatsiya hisobiga olingan kun *": "День постановки на учёт в пробации *",
  "Muddat shu kundan hisoblanadi (82-band)": "Срок исчисляется с этого дня (п. 82)",
  "Shartli hukm": "Условное осуждение",
  "Hukm chiqarilgan kun *": "День вынесения приговора *",
  "Sinov muddati shu kundan hisoblanadi (107-band)": "Испытательный срок исчисляется с этого дня (п. 107)",
  "Majburiy jamoat ishlari": "Обязательные общественные работы",
  "Muddat soat bilan o'lchanadi (37-band): kattalarga 120–480 soat, voyaga etmaganlarga 60–240 soat": "Срок измеряется в часах (п. 37): взрослым 120–480 часов, несовершеннолетним 60–240 часов",
  "Shaxs": "Личность",
  "Familiya *": "Фамилия *",
  "Ism *": "Имя *",
  "Sharifi": "Отчество",
  "Tug'ilgan sana": "Дата рождения",
  "Jinsi": "Пол",
  "Erkak": "Мужской",
  "Ayol": "Женский",
  "JSHSHIR (14 raqam)": "ПИНФЛ (14 цифр)",
  "Yashash manzili": "Адрес проживания",
  "Hukm": "Приговор",
  "Sud nomi": "Название суда",
  "Hukm sanasi": "Дата приговора",
  "Ish raqami": "Номер дела",
  "JK moddasi": "Статья УК",
  "168-modda 4-qismi «a» bandi": "ст. 168 ч. 4 п. «а»",
  "Jazo turi": "Вид наказания",
  "axloq tuzatish ishlari": "исправительные работы",
  "Jazo muddati": "Срок наказания",
  "Jazo turi * — muddat qaysi kundan boshlanishini shu belgilaydi": "Вид наказания * — определяет, с какого дня начинается срок",
  "Tanlanmagan — muddat hisoblanmaydi": "Не выбран — срок не рассчитывается",
  "Tayinlangan soat *": "Назначено часов *",
  "Ishlab bergan soat": "Отработано часов",
  "Nazoratga olingan sana": "Дата постановки на контроль",
  "Muddat — yil / oy / kun": "Срок — лет / месяцев / дней",
  "yil": "лет",
  "oy": "мес.",
  "kun": "дн.",
  "Muddat boshlangan sana * (avval jazo turini tanlang)": "Дата начала срока * (сначала выберите вид наказания)",
  "Izoh": "Комментарий",
  "Muddat hisoblanmadi": "Срок не рассчитан",
  "hisob chiqishi uchun jazo boshlangan sana va muddat kiritilishi kerak.": "для расчёта нужно указать дату начала и срок наказания.",
  "Belgilangan soat to'liq ishlab berilgan": "Назначенные часы отработаны полностью",
  "{ishlangan_soat} / {jami_soat} soat ishlab berildi": "Отработано {ishlangan_soat} из {jami_soat} ч",
  "Qolgan: {qolgan_matn}": "Осталось: {qolgan_matn}",
  "Jazo muddati tugagan": "Срок наказания истёк",
  "Muddat tugashiga {qolgan_kun} kun qoldi": "До окончания срока {qolgan_kun} дн.",
  "Jazo o'talmoqda — {foiz}% bajarildi": "Наказание отбывается — выполнено {foiz}%",
  "O'talgan muddat": "Отбытый срок",
  "{n} kun": "{n} дн.",
  "Qolgan muddat": "Оставшийся срок",
  "Tugash sanasi": "Дата окончания",
  "Jami muddat": "Общий срок",
  "Tergov qamog'ida o'tgan {hisobga_olingan_kun} kun hisobga olindi — muddat {sanaMatn} dan emas, {sanaMatn2} dan hisoblanmoqda.": "Зачтено {hisobga_olingan_kun} дн. под стражей — срок исчисляется не с {sanaMatn}, а с {sanaMatn2}.",
  "Muddatga qo'shilmaydigan {qoshilmaydigan_kun} kun sababli tugash sanasi shuncha kunga keyinga surildi.": "Из-за {qoshilmaydigan_kun} незасчитываемых дней дата окончания перенесена на столько же дней.",
  "Bu sana taxminiy.": "Эта дата приблизительная.",
  "Ro'yxatni ochib bo'lmadi.": "Не удалось открыть список.",
  "Familiya va ism kiriting": "Введите фамилию и имя",
  "{familiya} {ism} ro'yxatga qo'shildi.": "{familiya} {ism} добавлен(а) в реестр.",
  "Ma'lumotlar yangilandi.": "Данные обновлены.",
  "{toliqIsm} hisobdan chiqarilsinmi?\n\nYozuv bazada saqlanib qoladi, faqat ro'yxatda ko'rinmaydi.": "Снять {toliqIsm} с учёта?\n\nЗапись сохранится в базе, но не будет отображаться в списке.",
  "{toliqIsm} hisobdan chiqarildi.": "{toliqIsm} снят(а) с учёта.",
  "Bajarilmadi.": "Не выполнено.",
  "bo'yicha.": "(реестр района).",
  "Siz faqat o'z tumaningiz yozuvlarini ko'rasiz. Har bir ochish va o'zgartirish jurnalga yoziladi.": "Вы видите только записи своего района. Каждый просмотр и изменение записываются в журнал.",
  "Hisobda": "На учёте",
  "Muddati tugagan": "Срок истёк",
  "30 kundan kam qoldi": "Осталось менее 30 дней",
  "Yangi mahkum": "Новый осуждённый",
  "🔍 Familiya, ism, JK moddasi yoki JSHSHIR...": "🔍 Фамилия, имя, статья УК или ПИНФЛ...",
  "Mahkum qo'shish": "Добавить осуждённого",
  "F.I.Sh": "Ф.И.О.",
  "Holati": "Статус",
  "{foiz}% · {qolgan_kun} kun qoldi": "{foiz}% · осталось {qolgan_kun} дн.",
  "Muddat kiritilmagan": "Срок не указан",
  "Ochish": "Открыть",
  "Reyestr bo'sh. \"Mahkum qo'shish\" tugmasi bilan boshlang.": "Реестр пуст. Начните с кнопки «Добавить осуждённого».",
  "Hukm ma'lumoti kiritilmagan": "Данные приговора не указаны",
  "Tug'ilgan:": "Дата рождения:",
  "JSHSHIR:": "ПИНФЛ:",
  "Sud:": "Суд:",
  "Hukm sanasi:": "Дата приговора:",
  "Ish raqami:": "Номер дела:",
  "Nazoratga olingan:": "На контроле с:",
  "Manzil:": "Адрес:",
  "Hisobdan chiqarish": "Снять с учёта",
  "Ma'lumotlarni tahrirlash": "Редактировать данные",
};

export default lugat;
